import { useEffect, useState } from 'react'
import axios from 'axios'
import { useFormik } from 'formik'
import { toast } from 'react-toastify';
import { commonMessage, statusCodes } from '../../../Constants/generalConfig';
import { stateValidation } from '../../../Context/validation';
import { addState, countryList, logOutApi } from '../../../Context/api';
import { useNavigate } from 'react-router-dom';

const UseAddState = () => {
    const [countryData, setCountryData] = useState([])
    const [spinner, setSpinner] = useState(false)
    const adminData = JSON.parse(localStorage.getItem('adminData'));
    const navigate = useNavigate()
    useEffect(() => {
        countryListData()
    }, [])

    const logOutFun = () => {
        axios.post(logOutApi(), { deviceId: adminData.deviceId }, { headers: { Authorization: `Bearer ${adminData.token}` } }).then((resp) => {
            if (resp.data.code === statusCodes.ok) {
                localStorage.removeItem('adminData')
                navigate('/')
            }
        })
    }
    const countryListData = () => {
        axios.post(countryList(), { id: adminData.userId, isDeleted: true, isActive: true }, { headers: { Authorization: `Bearer ${adminData.token}` } }).then((resp) => {
            if (resp.data.code === statusCodes.ok) {
                setCountryData(resp.data.data)
            }
            else if (resp.data.code === statusCodes.tokenExpire) {
                logOutFun()
            }
        })
    }
    const stateAdd = useFormik({
        initialValues: {
            code: '',
            name: '',
            countryName: '',
        },
        validationSchema: stateValidation,
        onSubmit: (values) => {
            const data = {
                name: values.name.trim(),
                code: `${values.code.trim()}`,
                createdby_id: adminData.userId,
                countryId: values.countryName,
            }
            setSpinner(true)
            axios.post(addState(), { ...data }, { headers: { Authorization: `Bearer ${adminData.token}` } }).then((resp) => {
                if (resp.data.code === statusCodes.ok) {
                    toast.success(resp.data.message)
                    stateAdd.resetForm()
                    setSpinner(false)
                    navigate(-1)
                }
                else if (resp.data.code === statusCodes.tokenExpire) {
                    logOutFun()
                }
                else {
                    toast.error(resp.data.message)
                    setSpinner(false)
                }
            }).catch(() => {
                toast.error(commonMessage.networkError)
            })
        }
    })
  return {
    countryData,
    spinner,
    stateAdd
  }
}

export default UseAddState